/**
 * @generated SignedSource<<ccc0e9a9ab2d5de6d8f31886617d82c3>>
 * @relayHash 2aaa6cbc7241fba27bfa0d1ca6d7aeb7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 372846c937f01d8379e4577d6ab4cb87463fb1fb566f7a386c4bdd98f1ef2a96

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "hubAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v5 = {
      "kind": "InlineFragment",
      "selections": [{
        "args": [{
          "fields": [{
            "items": [{
              "kind": "Variable",
              "name": "ids.0",
              "variableName": "pageAri"
            }],
            "kind": "ListValue",
            "name": "ids"
          }],
          "kind": "ObjectValue",
          "name": "filter"
        }],
        "concreteType": "HelpCenterPage",
        "kind": "LinkedField",
        "name": "pages",
        "plural": true,
        "selections": [v4 /*: any*/, {
          "concreteType": "HelpCenterPageLayout",
          "kind": "LinkedField",
          "name": "pageLayout",
          "plural": false,
          "selections": [{
            "concreteType": "HelpCenterLayoutAdf",
            "kind": "LinkedField",
            "name": "layoutAdf",
            "plural": false,
            "selections": [{
              "concreteType": "HelpCenterLayoutAdfContentConnection",
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [{
                "concreteType": "HelpCenterLayoutAdfContentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "concreteType": "HelpCenterLayoutAdfContent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "name": "content"
                  }]
                }]
              }]
            }]
          }]
        }]
      }, {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterBrandingColors",
          "kind": "LinkedField",
          "name": "colors",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "primary"
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v6 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "message"
      }],
      "type": "QueryError"
    },
    v7 = {
      "kind": "InlineFragment",
      "selections": [v4 /*: any*/, {
        "kind": "ScalarField",
        "name": "isEnabled"
      }, {
        "kind": "ScalarField",
        "name": "position"
      }, {
        "concreteType": "CsmAiWidgetBrandingTheme",
        "kind": "LinkedField",
        "name": "theme",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "colorVibeVariant"
        }, {
          "kind": "ScalarField",
          "name": "radius"
        }, {
          "kind": "ScalarField",
          "name": "space"
        }, {
          "kind": "ScalarField",
          "name": "chatColor"
        }]
      }],
      "type": "CsmAiWidgetConfig"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v5 /*: any*/, v6 /*: any*/]
        }]
      }, {
        "args": v2 /*: any*/,
        "kind": "LinkedField",
        "name": "csmAi_getSupportWidget",
        "plural": false,
        "selections": [v7 /*: any*/]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [v4 /*: any*/],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }, {
        "args": v2 /*: any*/,
        "kind": "LinkedField",
        "name": "csmAi_getSupportWidget",
        "plural": false,
        "selections": [v3 /*: any*/, v7 /*: any*/]
      }]
    },
    "params": {
      "id": "372846c937f01d8379e4577d6ab4cb87463fb1fb566f7a386c4bdd98f1ef2a96",
      "metadata": {},
      "name": "hubQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "aca36ff6df61079d6abb2602d2c13e9b";
export default node;